import React from 'react';
import styled from 'styled-components';
import {ScrollBar} from '../../../../shared-components/mixin/scroll/scrollBar';
import {Table} from '../Table';
import {tableHoverSetup} from '../tableSetup/tableSetup';

const FixedTableScrollContainer = styled(ScrollBar)`
    position: relative;
    --padding-deduction: calc(var(--body-padding) - 10px);
    left: calc(0px - var(--padding-deduction));
    width: calc(100% + var(--padding-deduction));

    @-moz-document url-prefix() {
        overflow-y: auto;
        scrollbar-color: var(--scroll-bar-background) var(--scroll-bar-thumb);
    }
`;
const FixedTableWrapper = styled(ScrollBar)`
    --fixed-table-height-deduction: 200px;
    @media only screen and (max-height: 700px) {
        --fixed-table-height-deduction: 180px;
    }
    position: relative;
    overflow: auto;
    max-height: calc(100vh - var(--fixed-table-height-deduction));
    margin-bottom: var(--space-lg);
    padding-left: var(--padding-deduction);
    padding-right: 3px;
    padding-bottom: calc(var(--scrollbar-width) + 4px);

    ${Table.Wrapper} {
        ${({hover}) => tableHoverSetup(hover)};
        thead {
            position: sticky;
            top: 0px;
            z-index: var(--z-index-table-header);
        }
    }
`;

/**
 * @param {object} param0 Props
 * @description Important!!! Safari does not support all CSS elements the same way as Chrome does. One of these differences pertains to CSS positioning and pseudo-features in tables.
 *  Please make sure that when you are using the component <FixedTable>, you substitute the HTML element <thead></thead> with the styled component <Table.StickyThead>.
 */
const FixedTable = ({children, type, hover}) => (
    <FixedTableScrollContainer>
        <FixedTableWrapper hover={hover}>
            <Table type={type}>{children}</Table>
        </FixedTableWrapper>
    </FixedTableScrollContainer>
);

FixedTable.Wrapper = FixedTableWrapper;
export {FixedTable, FixedTableScrollContainer, FixedTableWrapper};
